import { render, staticRenderFns } from "./BicDetails.vue?vue&type=template&id=730953bd&"
import script from "./BicDetails.vue?vue&type=script&lang=js&"
export * from "./BicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730953bd')) {
      api.createRecord('730953bd', component.options)
    } else {
      api.reload('730953bd', component.options)
    }
    module.hot.accept("./BicDetails.vue?vue&type=template&id=730953bd&", function () {
      api.rerender('730953bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bic/BicDetails.vue"
export default component.exports